import {active} from "./const.js";
import $ from "jquery";

$('.js-tab').on('click', (event) => {
  $('.js-tab').removeClass(active);
  $(event.currentTarget).toggleClass(active);
  $('.js-tabContent').removeClass(active);
  const index = $('.js-tab').index(event.currentTarget);
  $('.js-tabContent').eq(index).addClass(active);
});

$('.js-tab2').on('click', (event) => {
  $('.js-tab').removeClass(active);
  $('.js-tabContent').removeClass(active);
  const index = $('.js-tab2').index(event.currentTarget);
  $('.js-tab').eq(index).addClass(active);
  $('.js-tabContent').eq(index).addClass(active);
});
